import { FC } from "react";

// A pack/bundle line on the warehouse screens (user 2026-10-11): purple, impossible to miss, with what goes in the
// parcel — each item × qty, its shelf slot, and the free gift. The pack itself has no shelf.
export interface PackInfo { name: string; badge?: string | null; components: { name: string; imageUrl?: string | null; qty: number; gift: boolean; location: string }[] }

export const PackBox: FC<{ pack: PackInfo; units?: number; compact?: boolean }> = ({ pack, units = 1, compact = false }) => (
    <div className="rounded-2xl border-4 border-fuchsia-500 bg-fuchsia-50 p-2.5">
        <p className="flex flex-wrap items-center gap-2 text-xl font-black text-fuchsia-800">
            <span className="rounded-xl bg-fuchsia-600 px-3 py-1 text-white">🎁 PACK · باك</span>
            <span className="text-base">حط هادشي كامل فنفس الكولي{units > 1 ? ` — ×${units}` : ""}</span>
        </p>
        <div className="mt-2 space-y-1.5">
            {pack.components.map((c, i) => (
                <div key={i} className="ltr flex items-center gap-2 rounded-xl bg-white p-1.5">
                    {c.imageUrl ? <img src={c.imageUrl} alt="" className={compact ? "h-10 w-10 rounded-lg object-contain" : "h-14 w-14 rounded-lg object-contain"} /> : <div className="h-10 w-10 rounded-lg bg-slate-100" />}
                    <span className="rounded-lg bg-fuchsia-700 px-2 py-0.5 text-lg font-black text-white">{c.qty * units}×</span>
                    <span className="min-w-0 flex-1 text-start text-base font-black uppercase text-slate-800">{c.name}</span>
                    {c.gift && <span className="rounded-lg bg-amber-400 px-2 py-0.5 text-sm font-black text-white">🎁 هدية</span>}
                    {c.location
                        ? <span className="rounded-lg bg-slate-900 px-2 py-0.5 font-mono text-base font-black text-white">📍 {c.location}</span>
                        : <span className="rounded-lg bg-red-100 px-2 py-0.5 text-sm font-black text-red-700">📍 ?</span>}
                </div>
            ))}
        </div>
    </div>
);
